<template>
  <div class="modal fade" ref="modalEle" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Dyspozycje robocze</h5>
          <button class="btn-close" @click="hide"></button>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="text-center py-5">
            Ładowanie...
          </div>

          <div v-else-if="!dispositions.length" class="text-muted text-center py-5">
            Brak dyspozycji roboczych
          </div>

          <div v-else class="accordion" id="draftDispositionsAccordion">
            <DraftDispositionRow
                v-for="dispo in dispositions"
                :key="dispo.id"
                :disposition="dispo"
                @refresh="loadDispositions"
                @execute="executeDisposition"
            />
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" @click="hide">Zamknij</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {Modal} from 'bootstrap';
import DraftDispositionRow from './DraftDispositionRow.vue';
import Swal from "sweetalert2";

export default {
  components: {DraftDispositionRow},

  data() {
    return {
      modalObj: null,
      dispositions: [],
      loading: false
    };
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  methods: {
    show() {
      this.loadDispositions();
      this.modalObj.show();
    },
    hide() {
      this.modalObj.hide();
    },
    async loadDispositions() {
      this.loading = true;
      const {data} = await axios.get(route('draft-dispositions.index'));
      this.dispositions = data;
      this.loading = false;
    },
    async executeDisposition(disposition) {
      const ok = await Swal.fire({
        icon: 'question',
        title: 'Dyspozycja',
        html: 'Czy na pewno chcesz zrobić dyspozycję?',
        showCancelButton: true,
        confirmButtonText: 'Tak',
        cancelButtonText: 'Anuluj',
        reverseButtons: true
      });

      if (!ok.isConfirmed) {
        return;
      }

      try {
        await axios.post(
            route('draft-dispositions.execute', {
              disposition: disposition.id
            })
        );

        this.showToast('success', 'Sukces', 'Dyspozycja została poprawnie wykonana');

        await this.loadDispositions();

      } catch (e) {
        console.log(e);
        this.showToast('error', 'Błąd', e?.response?.data?.message ?? 'Nie udało się wykonać dyspozycji');
      }
    },

    showToast(icon, title, message) {
      Swal.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  }
};
</script>
